var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafety(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.29567L16 6.24011V11.5592C16 13.2976 15.0971 14.9112 13.6155 15.8206L9 18.6533L4.38455 15.8206C2.90294 14.9112 2 13.2976 2 11.5592V6.24011L9 2.29567ZM14.6616 17.5251L9 21L3.33837 17.5251C1.26412 16.2521 0 13.993 0 11.5592V5.07143L9 0L18 5.07143V11.5592C18 13.993 16.7359 16.2521 14.6616 17.5251ZM13.7071 8.37378L14.2071 7.87378L12.7928 6.45957L12.2928 6.95957L11.2928 7.95957L7.99996 11.2525L6.84373 10.0962L5.91206 9.16457L4.49785 10.5788L5.42952 11.5104L7.29285 13.3738L7.99996 14.0809L8.70706 13.3738L12.7071 9.37378L13.7071 8.37378Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.37de16914848418d60a6822b0a8cbcd6.svg";
export { ForwardRef as ReactComponent };